import { MemberTypeEnum } from '@zaoblako/shared/modules/security/enums/member-type.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';

import * as yup from 'yup';

/** Abstract "member" (user or user group) response body - DTO signature */
export interface MemberFindInterface {
  /** Member type */
  type: MemberTypeEnum;
  /** Member unique ID */
  id: number;
  /** Member unique ID */
  name: string;
}

/** Abstract "member" (user or user group) response body - DTO schema */
export const MemberFindDto = SerdeDtoClass.create<MemberFindInterface>(SecurityDtoKeysEnum.MEMBER_FIND_DTO, {
  type: {
    label: 'Тип участника',
    serializer: yup
      .string()
      .oneOf(Object.values(MemberTypeEnum)),
  },
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  name: {
    label: 'Имя',
    serializer: yup.string(),
  },
});
